var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-bg"},[_c('div',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"header-content"},[_vm._v("支付二维码")])]),_c('div',{ref:"qrCodeDiv",attrs:{"id":"qrCode"}})])}
var staticRenderFns = []

export { render, staticRenderFns }